const getNcalayerWebsocket = function () {
    // eslint-disable-next-line no-undef
    const ncaWebSocket = new WebSocket(ncaLayerWsHost ?? 'wss://127.0.0.1:13579/');

    ncaWebSocket.onopen = function (event) {
        console.log('Connection opened');
    };

    ncaWebSocket.onclose = function (event) {
        if (event.wasClean) {
            console.log('connection has been closed');
        } else {
            console.log('Connection error');
            openDialog();
        }
        console.log('Code: ' + event.code + ' Reason: ' + event.reason);
    };

    ncaWebSocket.onmessage = function (event) {
        const result = JSON.parse(event.data);

        if (result?.result?.version) {
            return;
        }

        if (result != null) {
            const rw = {
                code: result.code,
                message: result.message,
                responseObject: result.responseObject,
                getResult: function () {
                    return this.result;
                },
                getMessage: function () {
                    return this.message;
                },
                getResponseObject: function () {
                    return this.responseObject;
                },
                getCode: function () {
                    return this.code;
                },
            };
            if (callback != null) {
                callback(rw);
            }
        }
    };

    return ncaWebSocket;
};

const connect = function() {
    return new Promise(function(resolve, reject) {
        const server = getNcalayerWebsocket();
        server.onopen = function() {
            resolve(server);
        };
        server.onerror = function(err) {
            reject(err);
        };
    });
};

let webSocket = null;
let callback = null;

export const blockScreen = function () {
    $.blockUI({
        message: '<img src="/images/loading.gif" /><br/>Подождите, выполняется операция в NCALayer...',
        css: {
            border: 'none',
            padding: '15px',
            backgroundColor: '#000000',
            '-webkit-border-radius': '10px',
            '-moz-border-radius': '10px',
            opacity: 0.5,
            color: '#ffffff',
        },
    });
};

export const openDialog = function () {
    if (confirm('Ошибка при подключении к NCALayer. Запустите NCALayer и нажмите ОК') === true) {
        webSocket = connect().then(unblockScreen);
    } else {
        unblockScreen();
    }
};

export const unblockScreen = function () {
    window.$.unblockUI();
};

export const getActiveTokens = function (callBack) {
    const getActiveTokens = {
        module: 'kz.gov.pki.knca.commonUtils',
        method: 'getActiveTokens',
    };
    callback = callBack;
    webSocket.send(JSON.stringify(getActiveTokens));
};

export const getKeyInfo = function (storageName, callBack) {
    const getKeyInfo = {
        module: 'kz.gov.pki.knca.commonUtils',
        method: 'getKeyInfo',
        args: [storageName],
    };
    callback = callBack;
    webSocket.send(JSON.stringify(getKeyInfo));
};

export const signXml = async function (storageName, keyType, xmlToSign, callBack) {
    if (!webSocket || webSocket.readyState !== WebSocket.OPEN) {
        webSocket = await connect();
    }

    const signXml = {
        module: 'kz.gov.pki.knca.commonUtils',
        method: 'signXml',
        args: [storageName, keyType, xmlToSign, '', ''],
    };
    callback = callBack;
    webSocket.send(JSON.stringify(signXml));
};

export const signXmls = function (storageName, keyType, xmlsToSign, callBack) {
    const signXmls = {
        module: 'kz.gov.pki.knca.commonUtils',
        method: 'signXmls',
        args: [storageName, keyType, xmlsToSign, '', ''],
    };
    callback = callBack;
    webSocket.send(JSON.stringify(signXmls));
};

export const createCAdESFromFile = function (storageName, keyType, filePath, flag, callBack) {
    const createCAdESFromFile = {
        module: 'kz.gov.pki.knca.commonUtils',
        method: 'createCAdESFromFile',
        args: [storageName, keyType, filePath, flag],
    };
    callback = callBack;
    webSocket.send(JSON.stringify(createCAdESFromFile));
};

export const createCAdESFromBase64 = function (storageName, keyType, base64ToSign, flag, callBack) {
    const createCAdESFromBase64 = {
        module: 'kz.gov.pki.knca.commonUtils',
        method: 'createCAdESFromBase64',
        args: [storageName, keyType, base64ToSign, flag],
    };
    callback = callBack;
    webSocket.send(JSON.stringify(createCAdESFromBase64));
};

export const createCAdESFromBase64Hash = function (storageName, keyType, base64ToSign, callBack) {
    const createCAdESFromBase64Hash = {
        module: 'kz.gov.pki.knca.commonUtils',
        method: 'createCAdESFromBase64Hash',
        args: [storageName, keyType, base64ToSign],
    };
    callback = callBack;
    webSocket.send(JSON.stringify(createCAdESFromBase64Hash));
};

export const applyCAdEST = function (storageName, keyType, cmsForTS, callBack) {
    const applyCAdEST = {
        module: 'kz.gov.pki.knca.commonUtils',
        method: 'applyCAdEST',
        args: [storageName, keyType, cmsForTS],
    };
    callback = callBack;
    webSocket.send(JSON.stringify(applyCAdEST));
};

export const showFileChooser = function (fileExtension, currentDirectory, callBack) {
    const showFileChooser = {
        module: 'kz.gov.pki.knca.commonUtils',
        method: 'showFileChooser',
        args: [fileExtension, currentDirectory],
    };
    callback = callBack;
    webSocket.send(JSON.stringify(showFileChooser));
};

export const changeLocale = function (language) {
    const changeLocale = {
        module: 'kz.gov.pki.knca.commonUtils',
        method: 'changeLocale',
        args: [language],
    };
    callback = null;
    webSocket.send(JSON.stringify(changeLocale));
};

export const createCMSSignatureFromFile = function (storageName, keyType, filePath, flag, callBack) {
    const createCMSSignatureFromFile = {
        module: 'kz.gov.pki.knca.commonUtils',
        method: 'createCMSSignatureFromFile',
        args: [storageName, keyType, filePath, flag],
    };
    callback = callBack;
    webSocket.send(JSON.stringify(createCMSSignatureFromFile));
};

export const createCMSSignatureFromBase64 = function (storageName, keyType, base64ToSign, flag, callBack) {
    const createCMSSignatureFromBase64 = {
        module: 'kz.gov.pki.knca.commonUtils',
        method: 'createCMSSignatureFromBase64',
        args: [storageName, keyType, base64ToSign, flag],
    };
    callback = callBack;
    webSocket.send(JSON.stringify(createCMSSignatureFromBase64));
};
